module.exports = __webpack_public_path__ + "../../../static/img/c_im_39.fb24365b.png";